import { QFilterGeneric } from './QFilterGeneric'

export class QFilterExcludeStates extends QFilterGeneric {
  name = "exclude_status";
  class_name = "QFilterExcludeStates";
  api_name = 'exclude_states';
  
  constructor(value) {
    if (value)  {
      super(value);
    } else {
      super(false);
    }
  }
}
